export const UY_ROLE_PREFIX = 'UY';

export const UY_COMITE_LEVEL_ROLES = ['UY_JEFE_CC'] as const;

export const UY_COMMITTEE_ONLY_ROLES = [
  'UYHO_JEFE_AD',
  'UY_COMITE_GCIA',
  'UY_COMITE_GCIA_COM',
  'UYHO_COMITE_CL',
  'UYCE_COMITE_CL',
  'UY_COMITE_CA',
  'UY_DIRECTOR_GG',
] as const;

const BASE_ROLE_CODES = ['PRD', 'COM', 'CMT', 'ADM', 'INS', 'ARQ'] as const;

export function isUruguayRoleCode(code: string): boolean {
  return code.startsWith(UY_ROLE_PREFIX);
}

export function isBaseRoleCode(code: string): boolean {
  return (BASE_ROLE_CODES as readonly string[]).includes(code);
}

export function isRoleSelectableForTenant(
  code: string,
  isUruguayEnabled: boolean
): boolean {
  return isUruguayEnabled
    ? isUruguayRoleCode(code) || isBaseRoleCode(code)
    : !isUruguayRoleCode(code);
}

export function hasCommitteeOnlyAccess(userRoles: string[]): boolean {
  return userRoles.some((r) =>
    (UY_COMMITTEE_ONLY_ROLES as readonly string[]).includes(r)
  );
}
